package com.macrofocus.eflux.components

import com.macrofocus.eflux.Area
import com.macrofocus.eflux.theme.ThemeContext
import js.objects.unsafeJso
import mui.material.Drawer
import mui.material.DrawerAnchor.Companion.left
import mui.material.DrawerVariant.Companion.permanent
import mui.material.PaperProps
import mui.material.styles.Theme
import mui.system.Box
import mui.system.SxProps
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.dom.html.ReactHTML.nav
import react.use
import web.cssom.*

external interface SidebarProps : PropsWithChildren {
    var uiscale: Double?
}

val Sidebar = FC<SidebarProps> {props ->
    var theme by use(ThemeContext)!!

//    val lastPathname = useLocation().pathname.substringAfterLast("/")

    Box {
        component = nav
        sx { gridArea = Area.Sidebar }

        Drawer {
            variant = permanent
            anchor = left

            sx = unsafeJso {
//                flexGrow = number(1.0)
//                flexShrink = number(1.0)
//                height = 100.pct - Sizes.Header.height
//                backdropFilter

                position = Position.absolute
                right = 310.px
                top = 16.px
            }

            val customBackground : (SxProps<Theme>) -> Unit = { it ->
                it.blurBackground(theme)
            }

            slotProps = unsafeJso {
                asDynamic().paper = unsafeJso<PaperProps> {
                    sx = unsafeJso {
                        //                    boxSizing = BoxSizing.borderBox
                        //                    position = Position.sticky

                        // Prevent the sidebar from extending to the bottom
                        height = Globals.unset

                        customBackground(this)

                        borderRight = Globals.unset
                        position = Position.absolute
                        this.left = Globals.unset
                        top = Globals.unset

                        overflowY = Overflow.visible

                        if (props.uiscale != 1.0) {
                            transform = "scale(${props.uiscale});".unsafeCast<Transform>()
                            transformBox = TransformBox.fillBox
                            transformOrigin = TransformOrigin(GeometryPosition.top, GeometryPosition.left)
                        }
                    }
                }
            }

            Box {
//                Toolbar()

                SidebarContent {}
            }
        }
    }
}

